import MPendingActions from './MPendingActions.vue';

export { MPendingActions };
export default MPendingActions;
